'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".CsrSignInWizard-module_pageWrapper__p23go{overflow-x:hidden}@media screen and (min-width:768px){.CsrSignInWizard-module_desktopHeightWrapper__mZIAH{min-height:calc(100vh - 250px)}}.CsrSignInWizard-module_footerPadding__q4vlT{padding-top:2rem;width:100%}@media screen and (max-width:768px){.CsrSignInWizard-module_footerPadding__q4vlT{bottom:0;position:fixed}}.CsrSignInWizard-module_footerPadding__q4vlT>footer>div{padding:1rem 1.5rem}";
var styles = {"pageWrapper":"CsrSignInWizard-module_pageWrapper__p23go","desktopHeightWrapper":"CsrSignInWizard-module_desktopHeightWrapper__mZIAH","footerPadding":"CsrSignInWizard-module_footerPadding__q4vlT"};
styleInject["default"](css_248z, '2c0109af-1e4d-4a3c-bd25-3ec98efdddbf');

exports["default"] = styles;
